module.exports = __webpack_public_path__ + "img/pistache-3.ca9de6f5.png";